import React, { FC } from "react";
import type { ContentfulCallToActionType, ContentfulContactModalType } from "@/types";
import { WhitePaperDownloadModal } from "../home/white-paper-download-modal";

interface WhitePaperDownloadResourceProps {
  cta: ContentfulCallToActionType;
  contentModal: ContentfulContactModalType
  pageSource: string
}

export const WhitePaperDownloadResource: FC<WhitePaperDownloadResourceProps> = ({ cta, contentModal, pageSource }) => {
  const [showContactModal, setShowContactModal] = React.useState(false);

  React.useEffect(() => {
    if (showContactModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showContactModal]);

  return (
    <section className="whitePaperDownload whitePaperResource">
      <div className="wrapper wrapper_lg resource">
        {cta && cta.buttonLabel &&
          <button
            className="link link_white link_full cta--link"
            onClick={() => {
              setShowContactModal(true);
            }}
            data-title={cta.buttonLabel}
          >
            <span>{cta.buttonLabel}</span>
          </button>
        }
      </div>
      {showContactModal && (
        <WhitePaperDownloadModal
          {...contentModal}
          {...cta}
          onClose={() => {
            setShowContactModal(false);
          }}
          sourcePage={pageSource}
        />
      )}
    </section>
  )
};
